












import { filterMixin } from '@/utils/mixins/filterMixin'
import { PropType } from 'vue'
import { Iterable } from '~/utils/interfaces'
import FlatFilter from './FlatFilter.vue'

export default filterMixin.extend({
  props: {
    serializeFilter: {
      type: Function as PropType<(filter: Iterable) => Iterable>,
      default: (filter: Iterable) => filter as (filter: Iterable) => Iterable,
    },
  },
  components: {
    FlatFilter,
  },
  methods: {
    newFilter() {
      this.$emit('filter', this.serializeFilter(this.filter))
    },
  },
})
